/*eslint-disable*/
import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { UserOutlined } from '@ant-design/icons';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import { message, List, Drawer, FloatButton, Tooltip, notification, Space } from 'antd';
import MenuItem from '@mui/material/MenuItem';
import Autocomplete from '@mui/material/Autocomplete';
import '../data.scss';
import { getUser, getAclMenu, getToken } from '../utils/common';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TableHead,
  Switch,
  Grid,
  Avatar,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { TreeView } from '@mui/x-tree-view/TreeView';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import 'react-dropdown-tree-select/dist/styles.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import Iconify from '../components/iconify';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Scrollbar from '../components/scrollbar';
import { UserListToolbar } from '../sections/@dashboard/user';
import { SmartshileService } from './dataset/service';

// ----------------------------------------------------------------------

export default function UserPage() {
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [email, setEmail] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [filter, setFilter] = useState('');
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [isSwitchOpen, setisSwitchOpen] = useState(false);
  const [isDeleteOpen, setisDeleteOpen] = useState(false);
  const [isSwitchOpender, setisSwitchOpender] = useState(false);
  const [allData, setAllData] = useState();
  const [isModalOpenrole, setModalOpenrole] = useState(false);
  const [statelabel, setStatelabel] = useState({ from: '', to: '', id: '', status: '', label: '', isactive: false });
  const [role, setRole] = useState(null);
  const [username, setUsername] = useState(getUser());
  const [acl, setAcl] = useState(getAclMenu('user'));
  const [invitation, setInvitation] = useState({ id: '', email: '', role: '', errorText: '' });
  const [resetpass, setResetpass] = useState();
  const [deletepass, setDeletepass] = useState();
  const [datas, setDatas] = useState([]);
  const [idAlreadyFetxh, setIdAlreadyFetch] = useState([]);
  const [parent, setParent] = useState([]);
  const { getDataSet } = SmartshileService();

  const [checkedItems, setCheckedItems] = useState([]);
  function checkAncestors(data, nodeId, status) {
    // Create a copy to avoid mutating original
    let updated = [...data];

    // Find the node with the given ID
    let node = updated.find((item) => item.id === nodeId);

    // Traverse up the parent chain
    while (node && node.parent_id) {
      const parentIndex = updated.findIndex((item) => item.id === node.parent_id);
      if (parentIndex !== -1) {
        updated[parentIndex] = { ...updated[parentIndex], check: status };
        node = updated[parentIndex]; // move up to the next ancestor
      } else {
        break;
      }
    }

    return updated;
  }

  function checkAncestorsIfChildrenChecked(data) {
    const mapById = Object.fromEntries(data.map((item) => [item.id, { ...item }]));

    // Build tree structure
    const childrenMap = {};
    data.forEach((item) => {
      if (!childrenMap[item.parent_id]) childrenMap[item.parent_id] = [];
      childrenMap[item.parent_id].push(item.id);
    });

    const areAllChildrenChecked = (id) => {
      const children = childrenMap[id] || [];
      return children.every((childId) => mapById[childId].check);
    };

    const propagateCheck = (id) => {
      if (!id || !mapById[id]) return; // prevent error if id not in map
      if (areAllChildrenChecked(id)) {
        mapById[id].check = true;
        const parentId = mapById[id].parent_id;
        propagateCheck(parentId);
      }
    };

    // Start from the deepest children (leaf nodes)
    Object.values(mapById).forEach((item) => {
      if (item.check) {
        propagateCheck(item.parent_id);
      }
    });

    return Object.values(mapById);
  }

  const handleCheck = (event, node, checkparent) => {
    let newCheckedItems = checkedItems != null ? [...checkedItems] : [];

    const checkChildren = (node, checked) => {
      if (checked) {
        newCheckedItems.push({
          id: node.id,
          type: node.type,
          parent_id: node.idparrent || '',
          check: true,
        });
      } else {
        // Function to get all descendant IDs of a node recursively
        function getDescendantIds(nodeId, items) {
          const children = items.filter((item) => item.parent_id === nodeId);
          let descendants = children.map((child) => child.id);

          for (const child of children) {
            descendants = descendants.concat(getDescendantIds(child.id, items));
          }

          return descendants;
        }

        // Uncheck 1759: remove it and all of its checked descendants
        function filterDataAfterUncheck(uncheckedId, data) {
          const descendants = getDescendantIds(uncheckedId, data);
          const idsToRemove = new Set();

          for (const item of data) {
            if (item.id === uncheckedId || descendants.includes(item.id)) {
              if (item.check) {
                idsToRemove.add(item.id);
              }
            }
          }

          return data.filter((item) => !idsToRemove.has(item.id));
        }

        newCheckedItems = filterDataAfterUncheck(node.id, newCheckedItems);
        const index = newCheckedItems.findIndex((item) => item.id === node.id);
        if (index > -1) {
          newCheckedItems.splice(index, 1);
        }
      }
      (node.children || []).forEach((child) => checkChildren(child, checked));
    };

    const checkParent = (node) => {
      if (!node.idparrent) return;
      const parentIndex = newCheckedItems.findIndex((item) => item.id === node.idparrent);
      const parentNode = findNodeById(parent, node.idparrent);

      if (parentNode) {
        const allChildrenChecked = parentNode.children.every((child) =>
          newCheckedItems?.some((item) => item.id === child.id && item.check)
        );
        const someChildrenChecked = parentNode.children?.some((child) =>
          newCheckedItems?.some((item) => item.id === child.id)
        );

        if (allChildrenChecked) {
          newCheckedItems = checkAncestors(newCheckedItems, parentNode.id, true);
          newCheckedItems = checkAncestorsIfChildrenChecked(newCheckedItems);

          if (parentIndex === -1) {
            newCheckedItems.push({
              id: parentNode.id,
              type: parentNode.type,
              parent_id: parentNode.idparrent || '',
              check: true,
            });
          }
        } else if (someChildrenChecked) {
          newCheckedItems.push({
            id: parentNode.id,
            type: parentNode.type,
            parent_id: parentNode.idparrent || '',
            check: false,
          });
          function updateCheckStatusById(items, targetId, newCheckValue) {
            return items.map((item) => (item.id === targetId ? { ...item, check: newCheckValue } : item));
          }

          newCheckedItems = updateCheckStatusById(newCheckedItems, parentNode.id, false);
        } else if (!someChildrenChecked && parentIndex > -1) {
          newCheckedItems.splice(parentIndex, 1);
        }
        checkParent(parentNode);
      }
    };

    checkChildren(node, event.target.checked);

    checkParent(node);

    // Remove duplicate entries
    const uniqueCheckedItems = [...new Map(newCheckedItems.map((item) => [item.id, item])).values()];

    setCheckedItems(uniqueCheckedItems);
  };

  const handleCheck2 = (node, checked, parentId) => {
    const newCheckedItems = checkedItems != null ? [...checkedItems] : [];

    const checkChildren = (node, checked) => {
      if (checked) {
        newCheckedItems.push({
          id: node.id,
          type: node.type,
          parent_id: String(node?.data?.parentId || parentId || ''),
          check: true,
        });
      } else {
        const index = newCheckedItems.findIndex((item) => item.id === node.id);
        if (index > -1) {
          newCheckedItems.splice(index, 1);
        }
      }
      (node.children || []).forEach((child) => checkChildren(child, checked));
    };

    // console.log('node will insert');
    // console.log(node);
    node.map((node2) => {
      checkChildren(node2, checked);
    });

    checkChildren(node, true);

    // Remove duplicate entries
    const uniqueCheckedItems = [...new Map(newCheckedItems.map((item) => [item.id, item])).values()];

    setCheckedItems(uniqueCheckedItems);
  };

  const findNodeById = (nodes, id) => {
    for (let node of nodes) {
      if (node.id === id) {
        return node;
      } else if (node.children) {
        const result = findNodeById(node.children, id);
        if (result) return result;
      }
    }
    return null;
  };

  const [stateSwitching, setsateSwitcing] = useState({ statusBefore: '', statusAfter: '', id: '' });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchInfo(window.REACT_APP_API_PURE + `user?max=` + rowsPerPage + '&first=' + newPage * rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    fetchInfo(window.REACT_APP_API_PURE + `user?max=` + parseInt(event.target.value, 10) + '&first=' + 0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    fetchInfo(window.REACT_APP_API_PURE + `user?search=${event.target.value}&max=` + rowsPerPage + `&first=0`);
  };

  const fetchInfo = (url) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData(d || []);
        fetchInfoTotal(window.REACT_APP_API_PURE + 'user/count', d);
      });
  };
  const fetchInfoTotal = (url, datalist) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setData({
          data: datalist || [],
          total: d || 0,
        });
      });
  };

  const fetchDatasetAceess = (url, setdata) => {
    return fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => {
        setdata(d?.dataset_access);
      });
  };

  const handleClickOpen = () => {
    if (rolevert != '') {
      fetchDatasetAceess(window.REACT_APP_API_PURE + 'user/datavieweraccess?id=' + rolevert.id, setCheckedItems);
      setInvitation({
        id: rolevert.id,
        email: rolevert.email,
        role: data2.filter((item) => {
          if (item.label === rolevert?.roles?.[0]?.name) {
            return item.id;
          }
        })[0].id,
        errorText: '',
      });
    } else {
      setInvitation({ id: '', email: '', role: '', errorText: '' });
    }

    setOpen(true);
  };

  const handleClose = async () => {
    setEmail('');
    setRole('');
    const item = {
      id: deletepass.id,
      username: statelabel.username,
    };
    fetch(window.REACT_APP_API_PURE + 'user/delete/request', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(item),
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('PromptRequestDelete.1'),
            placement: 'top',
            duration: 0,
          });
          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 0,
          });
        }
      });
    setisDeleteOpen(false);
  };
  const rejectChangedataset = () => {
    const formData = {
      id: invitation.id,
      action: statelabel.action,
    };

    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'edit/datasetacess/reject';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle the API response here

        if (data.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('EditDataAccess.1'),
            placement: 'top',
            duration: 0,
          });

          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
          setOpen(false);
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 0,
          });
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };
  const approveChangedataset = () => {
    const formData = {
      id: invitation.id,
      action: statelabel.action,
    };

    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'edit/datasetacess/approve';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle the API response here

        if (data.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('Sukses.1'),
            placement: 'top',
            duration: 0,
          });

          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
          setOpen(false);
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 0,
          });
          // navigate('/dashboard/app');
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };
  const requestChangedataset = (stats) => {
    const sortedResults = rearrangeCheckedResults(checkedItems);
    const filterDataByParentId = (data) => {
      // Create a set of all ids
      const idSet = new Set(data.map((item) => item.id));

      // Filter out items whose parent_id is not in the set of ids
      return data.filter((item) => item.parent_id === '' || idSet.has(item.parent_id));
    };

    function removeCheckIfIndeterminate(data) {
      // Iterate through the data and remove "check": true from indeterminate items
      var idForRemove = [];
      data.forEach((item) => {
        if (getCheckboxState(item, filterDataByParentId(sortedResults)) === 'indeterminate') {
          idForRemove.push(item.id);
        }
      });
      return removeCheckByIds(filterDataByParentId(sortedResults), idForRemove);
    }

    const formData = {
      id: invitation.id,
      dataset_access: removeCheckIfIndeterminate(parent),
    };
    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'edit/datasetacess/request';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle the API response here

        if (data.response_code === 200) {
          notification.success({
            message: 'Success',
            description: t('RequestDataAccess.1'),
            placement: 'top',
            duration: 0,
          });

          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage + '&first=' + page * rowsPerPage);
          setOpen(false);
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 0,
          });
          // navigate('/dashboard/app');
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };

  function removeCheckByIds(data, targetIds) {
    return data.map((item) => {
      if (targetIds.includes(item.id)) {
        const { check, ...rest } = item;
        return rest;
      }
      return item;
    });
  }
  notification.config({
    placement: 'top',
  });
  const sendInvitation = (status) => {
    const sortedResults = rearrangeCheckedResults(checkedItems);

    const formData = {
      email: invitation.email,
      role: invitation.label,
      status,
      id: invitation.id,
      dataset_access: sortedResults,
    };

    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'signup/invitation';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle the API response here

        if (data.response_code === 200) {
          if (statelabel.status_pendaftaran == 'Reject') {
            notification.success({
              message: 'Success',
              description: t('UserRejected.1'),
              placement: 'top',
              duration: 0,
            });
          } else {
            notification.success({
              message: 'Success',
              description: t('UserInvited.1'),
              placement: 'top',
              duration: 0,
            });
          }

          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage + '&first=' + page * rowsPerPage);
          setOpen(false);
        } else {
          alert(data.error_message);
          // navigate('/dashboard/app');
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };
  const sendConfirmresetdandelete = (status, action) => {
    // Perform additional actions here, like submitting the password
    const formData = {
      email: invitation.email,
      username: invitation.email,
      role: invitation.role,
      status,
      id: invitation.id,
      action: action,
    };

    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'user/resetpassworddelete/confirm';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Handle the API response here

        if (data.response_code === 200) {
          if (statelabel.status_pendaftaran == 'Reject') {
            notification.success({
              message: 'Success',
              description: t('UserRejected.2'),
              placement: 'top',
              duration: 0,
            });
          } else {
            notification.success({
              message: 'Success',
              description: t('DeletePrompt.2'),
              placement: 'top',
              duration: 0,
            });
          }

          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
          setOpen(false);
        } else {
          notification.error({
            message: 'Error',
            description: data.error_message,
            placement: 'top',
            duration: 0,
          });
          // navigate('/dashboard/app');
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
  };

  const handleSwitchChange = ({ before, after, id }) => {
    setsateSwitcing({ statusBefore: before, statusAfter: after, id: id });
    setisSwitchOpen(true);
  };

  const handleresetChange = () => {
    setisSwitchOpender(true);
    setAnchorEl(false);
  };

  const fetchInfo2 = (url2, role) => {
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    const requestOptions = {
      method: 'GET',
      headers: headerson,
    };

    return fetch(url2, requestOptions)
      .then((res) => res.json())
      .then((d) => {
        setData2(d.data);
      });
  };

  const handleCloseConfirmationModal = () => {
    setConfirmationModalOpen(false);
  };
  const handleClosepop = () => {
    setOpen(false);
    setInvitation((current) => ({ ...current, is_edit_dataset: '' }));
  };
  const handleCloseSwitchnModal = () => {
    setisSwitchOpen(false);
  };
  const handleCloseSwitchnModalder = () => {
    setisSwitchOpender(false);
  };

  const handleCloseDeleteModalder = () => {
    setisDeleteOpen(false);
  };
  const [isLoading, setIsLoading] = useState(false);
  const handleOpenDeleteModalder = () => {
    setisDeleteOpen(true);
  };

  const { t } = useTranslation();

  const handleValueChange = (
    label,
    event,
    newValue,
    id,
    idUser,
    status,
    is_active,
    status_keterangan,
    status_pendaftaran,
    action
  ) => {
    if (newValue.label != id) {
      setStatelabel({
        status_pendaftaran: status_pendaftaran,
        from: id,
        to: newValue.label,
        id: idUser,
        status: status,
        label: label,
        isactive: is_active,
        status_keterangan: status_keterangan,
        action: action,
      });
      setConfirmationModalOpen(true);
    }
    if (newValue.id === '--') {
      setStatelabel({
        status_pendaftaran: status_pendaftaran,
        from: id,
        to: newValue.label,
        id: idUser,
        status: status,
        label: label,
        isactive: is_active,
        status_keterangan: status_keterangan,
        action: action,
      });
      setConfirmationModalOpen(true);
    }

    // setSelectedValue1(newValue);
    // setSelectedid(id);
    // console.log(`Selected value: ${newValue}, Username: ${id}`);
    // handleOpenConfirmationModal();
  };

  const handleConfirm = (newValue) => {
    setIsLoading(true);
    if (statelabel.action === 'update dataset access') {
      switch (statelabel.status_pendaftaran) {
        case 'Reject':
          rejectChangedataset();
          break;
        default:
          approveChangedataset();
          break;
      }
    } else {
      if (
        statelabel.status_keterangan === 'Waiting Approval' &&
        (allData?.attributes?.target_role?.[0] == '' || allData?.attributes?.target_role?.[0] == undefined)
      ) {
        if (statelabel.status_pendaftaran == 'Reject') {
          switch (statelabel.action) {
            case 'Create New Account':
              sendInvitation('Reject');
              break;
            default:
              sendConfirmresetdandelete('Reject', statelabel.action);
              break;
          }
        } else {
          switch (statelabel.action) {
            case 'Create New Account':
              sendInvitation('');
              break;
            default:
              sendConfirmresetdandelete('', statelabel.action);
              break;
          }
        }
      } else {
        const formData = {
          id: statelabel.id,
          role: statelabel.from,
          target_role: statelabel.to,
          updated_by: getUser(),
          status: statelabel.status,
        };
        // Define the API endpoint URL
        const apiUrl = window.REACT_APP_API_PURE + 'user/edit';

        // Set up the request headers with the Bearer Token and Content-Type
        const headerson = new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        });

        // Create the request options
        const requestOptions = {
          method: 'POST',
          headers: headerson,
          body: JSON.stringify(formData), // Convert the form data to JSON
        };

        // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
        fetch(apiUrl, requestOptions)
          .then((data) => {
            // Handle the API response here

            if (statelabel.status == 'Waiting Approval') {
              notification.success({
                message: 'Success',
                description: t('RolePromp.3', { data: translatedData }),
                placement: 'top',
                duration: 0,
              });
            } else {
              if (statelabel.status_pendaftaran == 'Reject') {
                notification.success({
                  message: 'Success',
                  description: t('RolePromp.5', { data: translatedData }),
                  placement: 'top',
                  duration: 0,
                });
              } else {
                notification.success({
                  message: 'Success',
                  description: t('RolePromp.1', { data: translatedData }),
                  placement: 'top',
                  duration: 0,
                });
              }
            }

            fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
          })
          .catch((error) => {
            fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
            if (statelabel.status == 'Waiting Approval') {
              notification.error({
                message: 'Error',
                description: t('RolePromp.4', { data: translatedData }),
                placement: 'top',
                duration: 0,
              });
            } else {
              notification.success({
                message: 'Success',
                description: t('RolePromp.2', { data: translatedData }),
                placement: 'top',
                duration: 0,
              });
            }
            console.error('Error:', error);
            // fetchInfo(window.REACT_APP_API_PURE +'user/list');
          });
      }
    }
    setTimeout(() => {
      setIsLoading(false);
      handleCloseConfirmationModal();
    }, 2000);
  };
  const validateEmail = (email) => {
    // Regular expression for basic email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const handleConfirmSwitch = (newValue) => {
    setIsLoading(true);
    // var newStatus = '';
    // if (statelabel.status === 'Active') {
    //   newStatus = 'Waiting Approval';
    // }
    const formData = {
      id: stateSwitching.id,
      is_active: stateSwitching.statusAfter,
      status: stateSwitching.statusAfter ? 'Active' : 'InActive',
    };
    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'user/edit';

    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    fetch(apiUrl, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.response_code === 200) {
          fetchInfo(window.REACT_APP_API_PURE + 'user?max=' + rowsPerPage);
          notification.success({
            message: 'Success',
            description:
              t('SwitchPromp.1') + ' ' + (stateSwitching.statusAfter ? t('Active.1') : t('StatusInactive.1')),
            placement: 'top',
            duration: 0,
          });
        }
      })
      .catch((error) => {
        notification.error({
          message: 'Error',
          description: t('SwitchPromp.2') + ' ' + (stateSwitching.statusAfter ? t('Active.1') : t('StatusInactive.1')),
          placement: 'top',
          duration: 0,
        });
        console.error('Error:', error);
      });
    setTimeout(() => {
      setIsLoading(false);
      handleCloseSwitchnModal();
    }, 2000);
  };

  const handleConfirmReset = () => {
    setIsLoading(true);
    const formData = {
      email: resetpass.email,
    };
    // Define the API endpoint URL
    const apiUrl = window.REACT_APP_API_PURE + 'user/password/reset/request';

    // Set up the request headers with the Bearer Token and Content-Type
    const headerson = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`,
    });

    // Create the request options
    const requestOptions = {
      method: 'POST',
      headers: headerson,
      body: JSON.stringify(formData), // Convert the form data to JSON
    };

    // Send a POST request to the API with the form data, Bearer Token, and Content-Type in the headers
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(t('PromptRequestResetReject.1'));
        } else {
          notification.success({
            message: 'Success',
            description: t('PromptRequestResetSuccess.1'),
            placement: 'top',
            duration: 0,
          });
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the request
        console.error('Error:', error);
      });
    setTimeout(() => {
      setIsLoading(false);
      handleCloseSwitchnModalder();
    }, 2000);
  };

  const handleCancel = () => {
    // Revert the selection or take other actions if the user cancels
    // setSelectedValue1(null);
    handleCloseConfirmationModal();
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const [limit, setLimit] = useState(1);
  const scrollableRef = useRef(null);
  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setIdAlreadyFetch([]);
    settempdata([]);
    fetchInfrecord(window.REACT_APP_API_PURE + 'datasetrecord?q=' + event.target.value, setParent);
  };
  const [tempdata, settempdata] = useState([]);
  const fetchInfrecord = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.code === 401) {
          // setData('');
        } else {
          setdata(d);
        }
      });
  };

  const handleScroll = useCallback(
    () => {
      const element = scrollableRef.current;

      // console.log(element.scrollHeight - element.scrollTop === element.clientHeight - 0.25);
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
        inquiryAccountNumber(lastfolderid, limit + 1, { recreate: true, parentCheck: false });
        setLimit(limit + 1);
      }
    },
    [tempdata, settempdata] //[fetchData, lastfolderid]
  );

  useEffect(() => {
    const element = scrollableRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    fetchInfrecord(window.REACT_APP_API_PURE + 'datasetrecord', setParent);
    fetchInfo(window.REACT_APP_API_PURE + `user?max=` + rowsPerPage + '&first=' + 0);
    fetchInfo2(window.REACT_APP_API_PURE + 'reference/list?kode=F004');
  }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rolevert, setRolevert] = React.useState('');
  const opender = Boolean(anchorEl);
  const handleClickers = (event, index, id) => {
    setAnchorEl(event.currentTarget);

    setResetpass({ email: index });
    setDeletepass({ id: id });
  };
  const handleclickdelete = (event, index, id) => {
    setAnchorEl(event.currentTarget);
    setDeletepass({ id: index });
  };
  const handleClosing = () => {
    setAnchorEl(null);
  };

  const handleYesClick = () => {
    closeModal();
  };
  function DialogChangeRole() {
    return (
      <Dialog open={isConfirmationModalOpen} onClose={handleCloseConfirmationModal}>
        <DialogTitle>{t('Confirmation.1')}</DialogTitle>
        <DialogContent>{statelabel.label}</DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>{t('CancelButton.1')}</Button>
          <LoadingButton
            disabled={isLoading}
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            onClick={handleConfirm}
          >
            {isLoading ? 'Loading...' : t('Confirm.1')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  function DialogSwitch() {
    return (
      <Dialog open={isSwitchOpen} onClose={handleCloseSwitchnModal}>
        <DialogTitle>{t('Confirmation.1')}</DialogTitle>
        <DialogContent>
          {t('AreYuSureSwitch.1')}{' '}
          <span style={{ fontWeight: 'bold' }}>
            {stateSwitching.statusBefore ? t('Active.1') : t('StatusInactive.1')}
          </span>{' '}
          {t('AreYuSureSwitch.2')}{' '}
          <span style={{ fontWeight: 'bold' }}>
            {stateSwitching.statusAfter ? t('Active.1') : t('StatusInactive.1')}
          </span>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSwitchnModal}>{t('CancelButton.1')}</Button>
          <LoadingButton
            disabled={isLoading}
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            onClick={handleConfirmSwitch}
          >
            {isLoading ? 'Loading...' : t('Confirm.1')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  function DialogReset() {
    return (
      <Dialog open={isSwitchOpender} onClose={handleCloseSwitchnModalder}>
        <DialogTitle>{t('Confirmation.1')}</DialogTitle>
        <DialogContent>{t('ResetPrompt.1')}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSwitchnModalder}>{t('CancelButton.1')}</Button>
          <LoadingButton
            disabled={isLoading}
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            onClick={handleConfirmReset}
          >
            {isLoading ? 'Loading...' : t('Confirm.1')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  function DialogDelete() {
    return (
      <Dialog open={isDeleteOpen} onClose={handleCloseDeleteModalder}>
        <DialogTitle>{t('Confirmation.1')}</DialogTitle>
        <DialogContent>{t('DeletePrompt.1')}</DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModalder}>{t('CancelButton.1')}</Button>
          <LoadingButton
            style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
            onClick={handleClose}
          >
            {t('Confirm.1')}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    );
  }

  const fakeDataUrl = window.REACT_APP_API_PURE + 'user/sessionlist?first=0&max=10000000&type=ALL';
  useEffect(() => {
    const fetchData = () => {
      fetch(fakeDataUrl, {
        headers: { Authorization: `Bearer ${getToken()}` },
      })
        .then((res) => res.json())
        .then((d) => {
          const currentTime = new Date();
          const filteredData = d?.filter((item) => {
            const lastAccessTime = new Date(parseInt(item.lastAccess));
            const timeDifference = (currentTime.getTime() - lastAccessTime.getTime()) / (1000 * 60); // Calculate time difference in minutes
            return timeDifference <= 1; // Show only if lastAccessed is within 1 minute from real time
          });
          setDatas(filteredData);
        });
    };

    const interval = setInterval(fetchData, 2000); // Fetch data every 5 seconds

    return () => {
      clearInterval(interval); // Clear the interval when the component is unmounted
    };
  }, []);

  const [opendraw, setOpendraw] = useState(false);

  const onClosedraw = () => {
    setOpendraw(false);
  };
  const handleClickbutton = () => {
    setOpendraw(true);
  };
  const filterDuplicates = (datas) => {
    // Assuming each object has a unique identifier called 'id'
    const filteredData = datas.filter(
      (item, index, self) => index === self.findIndex((t) => t.username === item.username)
    );
    return filteredData;
  };
  const getCheckboxState = (node, checkedItems) => {
    if (node.children && node.children.length > 0) {
      const allChildrenChecked = node.children.every((child) => getCheckboxState(child, checkedItems) === 'checked');
      const someChildrenChecked = node.children?.some((child) => getCheckboxState(child, checkedItems) !== 'unchecked');
      if (allChildrenChecked) {
        return 'checked';
      } else if (someChildrenChecked) {
        return 'indeterminate';
      } else {
        return 'unchecked';
      }
    } else {
      return checkedItems?.some((item) => item.id === node.id) ? 'checked' : 'unchecked';
    }
  };

  const filteredData = filterDuplicates(datas);
  const renderTree = (nodes, first, namaNode) => (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={
        <Grid container direction={'row'} spacing={1}>
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    checkedItems?.some((item) => item.id === nodes.id) ||
                    (checkedItems?.some(
                      (item) => item.id === nodes.idparrent && item.check == true && nodes.type == 'file'
                    ) &&
                      getCheckboxState(nodes, checkedItems) === 'indeterminate')
                  }
                  onChange={(event) => {
                    handleCheck(event, nodes);
                  }}
                  onClick={(e) => e.stopPropagation()}
                  indeterminate={
                    getCheckboxState(nodes, checkedItems) === 'indeterminate' ||
                    checkedItems?.some((item) => item.id === nodes.id && item.check == false && nodes.type == 'folder')
                  }
                  icon={<CheckBoxOutlineBlank />}
                  checkedIcon={<CheckBox />}
                  indeterminateIcon={<IndeterminateCheckBoxIcon />}
                />
              }
              label={nodes.name}
              key={nodes.id}
            />
          </Grid>
        </Grid>
      }
      onClick={async () => {
        const isChecked = checkedItems?.some((item) => {
          const targetId = nodes.id;
          return (
            item.id === targetId && item.check === true && getCheckboxState(nodes, checkedItems) !== 'indeterminate'
          );
        });
        await inquiryAccountNumber(nodes.id, 1, { recreate: false, parentCheck: isChecked });
      }}
    >
      {Array.isArray(nodes.children) ? (
        nodes.children.map((node) => renderTree(node, false, nodes.name))
      ) : nodes?.data?.recordCount > 0 ? (
        <span />
      ) : null}
    </TreeItem>
  );

  const inquiryAccountNumber = useCallback(async (id, limit, { recreate = false, parentCheck = false }) => {
    setIdAlreadyFetch((curr) => [...curr, id]);

    if (idAlreadyFetxh.includes(id) && !recreate) {
      return;
    }
    try {
      const res = await getDataSet(id, getToken(), limit);
      if (res.data.length > 0) {
        const newData = res.data.filter((item) => !tempdata?.some((data) => data.id === item.id));

        const isUsedAsParent = checkedItems?.some((item) => item.parent_id === id);
        if (!isUsedAsParent) {
          handleCheck2(newData, parentCheck, id);
        }

        settempdata((curr) => [...curr, ...newData.map((item) => ({ idparrent: id, ...item }))]);
      }
      if (res.data.length > 0) {
        const addChildToNode = (nodes, parentId) => {
          const newData = res.data.filter((item) => !tempdata?.some((data) => data.id === item.id));
          return nodes.map((node) => {
            if (node.id === parentId) {
              return {
                ...node,
                children: [...newData.map((item) => ({ idparrent: id, ...item }))],
              };
            } else if (node?.children && node?.children?.length > 0) {
              return {
                ...node,
                children: addChildToNode(node?.children, parentId),
              };
            } else {
              return node;
            }
          });
        };

        setParent((prevData) => addChildToNode(prevData, id));
      }
      return res.data;
    } catch (error) {
      console.log(error);
    }
  });
  const translatedData = statelabel.to ? t(`roledata.${statelabel.to}`) : null;

  const handleClickInvite = () => {
    setIsLoading(true);
    if (invitation.email !== '' && invitation.role !== '' && validateEmail(invitation.email)) {
      if (invitation.is_edit_dataset != '') {
        requestChangedataset();
      } else {
        sendInvitation('Waiting Approval');
      }
    } else {
      setInvitation({
        ...invitation,
        errorText: validateEmail(invitation.email) ? t('Email and Role is required') : t('Email is not valid'),
      });
    }
    // Simulate an async operation like an API call
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };
  return (
    <>
      <Helmet>
        <title> User Management | SmartShield </title>
      </Helmet>
      <Dialog
        fullWidth={'lg'}
        maxWidth={'lg'}
        PaperProps={{ style: { maxHeight: '90vh', minHeight: '20vh' } }}
        open={open}
        onClose={handleClosepop}
      >
        <DialogTitle>{rolevert != '' ? 'Edit Dataset Access' : t('InvPeople.1')}</DialogTitle>
        <DialogContent>
          <Grid item container direction={'row'} justifyContent={'space-between'}>
            <Grid item xs={6} style={{ flex: 1 }}>
              <TextField
                className="my-3"
                disabled={rolevert != '' && invitation.is_edit_dataset != ''}
                style={{ width: '40ch', flex: 1 }}
                label="Email"
                id="email"
                type="text"
                value={invitation.email}
                onChange={(event) => setInvitation({ ...invitation, email: event.target.value, errorText: '' })}
              />
            </Grid>
            <Grid item xs={6} style={{ flex: 1 }}>
              <Autocomplete
                disabled={!invitation.email || rolevert != '' || invitation.is_edit_dataset != ''}
                className="my-3"
                id={`combo-box-demo-`} // Unique ID for each Autocomplete
                options={[...data2?.filter((element) => element.label !== 'super_admin')]}
                value={(data2 || []).find((e) => e.id === invitation.role)}
                onChange={(event, newValue) => {
                  setInvitation({ ...invitation, role: newValue.id, errorText: '', label: newValue.label });
                  setCheckedItems([]);
                  setFilter('');
                }}
                renderInput={(params) => <TextField placeholder={t('SelectRole.1')} key={params.id} {...params} />}
              />
            </Grid>

            <Grid item xs={12} container direction={'row'}>
              {invitation.role != 'f2714ec9-ab30-4585-bc41-babd5f4af4e4' ? (
                ''
              ) : (
                <Grid item xs={12} container direction={'row'}>
                  <Grid item xs={12}>
                    <TextField
                      label="Set Data Record Viewing Permission"
                      variant="outlined"
                      value={filter}
                      size="small"
                      onChange={handleFilterChange}
                      style={{ marginBottom: '20px' }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                      {parent.map((node) => renderTree(node, true, node.name))}
                    </TreeView>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item style={{ position: 'absolute', bottom: 16, right: 16 }}>
              <Button
                variant="outlined"
                disabled={isLoading}
                style={{ backgroundColor: isLoading ? 'gray' : '#12A2CE', color: 'white' }}
                onClick={() => {
                  handleClickInvite();
                }}
              >
                {isLoading ? 'Loading...' : t('Submit.1')}
              </Button>
            </Grid>
          </Grid>
          <Typography style={{ color: 'red' }}>{invitation.errorText}</Typography>
          {/* </Grid> */}
        </DialogContent>
      </Dialog>
      {DialogChangeRole()}
      {DialogSwitch()}
      {DialogReset()}
      {DialogDelete()}
      <Container>
        <Stack direction="row" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Users
            <div>
              <Typography variant="h5" style={{ color: 'text.disabled' }} gutterBottom>
                {data?.total || 0} {t('Member.1')}
              </Typography>
            </div>
          </Typography>
          <div className="grid justify items-end" style={{ display: 'flex', alignItems: 'center' }}>
            <UserListToolbar numSelected={selected?.length} filterName={filterName} onFilterName={handleFilterByName} />
            <Button
              disabled={!acl.create}
              className="px-6 py-3"
              style={{ backgroundColor: !acl?.create ? 'gray' : '#12A2CE', color: 'white' }}
              variant="contained"
              onClick={() => {
                handleClickOpen();
                setRolevert('');
                setInvitation((current) => ({ ...current, is_edit_dataset: '' }));
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              {t('AddUser.1')}
            </Button>
          </div>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <Table>
                <TableHead>
                  <TableRow className="custom-table-row">
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Nomor.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>Email</StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('StatusActive.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('StatusActive.2')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Role.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}> </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data && Array.isArray(data?.data) ? (
                    data?.data?.map((index, row) => {
                      return (
                        <TableRow hover key={row}>
                          <TableCell component="th" scope="row" alignItems="center">
                            {page * rowsPerPage + row + 1}
                            {/* {row + 1} */}
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            {index.email}
                          </TableCell>
                          <TableCell component="th" scope="row" align="left" padding="none">
                            {acl.update &&
                            index?.attributes?.status?.[0] == 'Waiting Approval' &&
                            index?.attributes?.updated_by?.[0] !== username ? (
                              <Grid container direction="row" spacing={2}>
                                <Grid item>
                                  <Tooltip
                                    placement="topLeft"
                                    title={
                                      index?.attributes?.action?.[0] === 'delete'
                                        ? 'Delete User'
                                        : index?.attributes?.action?.[0] === 'reset'
                                        ? 'Reset User Password'
                                        : index?.attributes?.action?.[0] === 'update dataset access'
                                        ? 'Update Dataset Access'
                                        : index?.attributes?.action?.[0]
                                        ? 'Change Role'
                                        : 'Add User'
                                    }
                                  >
                                    <span
                                      style={{
                                        color: 'white',
                                        paddingBottom: 10,
                                        paddingTop: 10,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        borderRadius: 8,
                                        backgroundColor: 'red',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => {
                                        setAllData(index);
                                        setInvitation({ id: index.id, email: index.email });
                                        setStatelabel({ ...statelabel, action: index?.attributes?.action?.[0] });
                                        handleValueChange(
                                          index?.attributes?.status[0] == 'Waiting Approval' &&
                                            index?.attributes?.action?.[0]
                                            ? `${t('AreYuSur.1')} ${
                                                index?.attributes?.action?.[0] == 'reset'
                                                  ? 'reseting password'
                                                  : index?.attributes?.action?.[0] == 'delete'
                                                  ? 'deleting'
                                                  : index?.attributes?.action?.[0] == 'update dataset access'
                                                  ? 'updating dataset access'
                                                  : index?.attributes?.action?.[0]
                                              } ${t('AreYuSureApprove.7')}`
                                            : index?.attributes?.target_role?.[0]
                                            ? `${t('AreYuSureReject.5')} ${t('AreYuSureReject.2')} ${t(
                                                'AreYuSureReject.3'
                                              )}`
                                            : `${t('AreYuSureReject.6')}`,
                                          '',
                                          { label: index?.attributes?.target_role?.[0], id: '--' },
                                          index?.attributes?.target_role?.[0],
                                          index.id,
                                          'Reject',
                                          true,
                                          index?.attributes?.status[0],
                                          'Reject',
                                          index?.attributes?.action?.[0]
                                        );
                                      }}
                                    >
                                      {t('Reject.1')}
                                    </span>
                                  </Tooltip>
                                </Grid>
                                <Grid item>
                                  <Tooltip
                                    placement="topLeft"
                                    title={
                                      index?.attributes?.action?.[0] === 'delete'
                                        ? 'Delete User'
                                        : index?.attributes?.action?.[0] === 'reset'
                                        ? 'Reset User Password'
                                        : index?.attributes?.action?.[0] === 'update dataset access'
                                        ? 'Update Dataset Access'
                                        : index?.attributes?.target_role?.[0]
                                        ? 'Change Role'
                                        : 'Add User'
                                    }
                                  >
                                    <span
                                      style={{
                                        color: 'white',
                                        paddingBottom: 10,
                                        paddingTop: 10,
                                        paddingLeft: 20,
                                        paddingRight: 20,
                                        borderRadius: 8,
                                        backgroundColor: '#12A2CE',
                                        cursor: 'pointer',
                                      }}
                                      onClick={() => {
                                        setAllData(index);
                                        setInvitation({ id: index.id, email: index.email });
                                        setStatelabel({
                                          ...statelabel,
                                          status_pendaftaran: '',
                                          action: index?.attributes?.action?.[0],
                                        });
                                        handleValueChange(
                                          index?.attributes?.status[0] == 'Waiting Approval' &&
                                            index?.attributes?.action?.[0]
                                            ? `${t('AreYuSureApprove.1')} ${
                                                index?.attributes?.action?.[0] == 'reset'
                                                  ? 'reseting password'
                                                  : index?.attributes?.action?.[0] == 'delete'
                                                  ? 'deleting'
                                                  : index?.attributes?.action?.[0] == 'update dataset access'
                                                  ? 'updating dataset access'
                                                  : index?.attributes?.action?.[0]
                                              } ${t('AreYuSureApprove.7')}`
                                            : index?.attributes?.target_role?.[0]
                                            ? `${t('AreYuSureApprove.5')} ${t('AreYuSureApprove.2')} ${t(
                                                'AreYuSureApprove.3'
                                              )}`
                                            : `${t('AreYuSureApprove.6')}`,
                                          '',
                                          { label: index?.attributes?.target_role?.[0], id: '--' },
                                          index?.attributes?.target_role?.[0],
                                          index.id,
                                          'Approve',
                                          true,
                                          index?.attributes?.status[0],
                                          '',
                                          index?.attributes?.action?.[0]
                                        );
                                      }}
                                    >
                                      {t('Approve.1')}
                                    </span>
                                  </Tooltip>
                                </Grid>
                              </Grid>
                            ) : (
                              <span
                                style={{
                                  color: 'white',
                                  paddingBottom: 10,
                                  paddingTop: 10,
                                  paddingLeft: 20,
                                  paddingRight: 20,
                                  borderRadius: 8,
                                  backgroundColor:
                                    index?.attributes?.status?.[0] === 'InActive'
                                      ? 'red'
                                      : index?.attributes?.status?.[0] === 'Waiting Approval'
                                      ? '#8766EC'
                                      : index?.attributes?.status?.[0] === 'Waiting Activation' ||
                                        index?.attributes?.status?.[0] === 'Waiting Reset'
                                      ? '#FFCE4A'
                                      : !index.enabled
                                      ? 'red'
                                      : index?.attributes?.status?.[0] === 'Active' ||
                                        index?.attributes?.status?.[0] == null
                                      ? '#12A2CE'
                                      : '#FFCE4A',
                                }}
                              >
                                {index?.attributes?.status[0] === 'InActive'
                                  ? t('StatusInactive.1')
                                  : index?.attributes?.status[0] === 'Waiting Approval'
                                  ? t('StatusWaitApproval.1')
                                  : index?.attributes?.status[0] === 'Waiting Reset'
                                  ? t('StatusWaitReset.1')
                                  : index?.attributes?.status[0] === 'Waiting Activation'
                                  ? t('StatusWaitActivation.1')
                                  : !index.enabled
                                  ? t('StatusInactive.1')
                                  : index?.attributes?.status[0] === 'Active' || index?.attributes?.status[0] == null
                                  ? t('Active.1')
                                  : index?.attributes?.status[0]}
                              </span>
                            )}
                          </TableCell>

                          <TableCell>
                            <Switch
                              disabled={
                                index?.attributes?.status[0] == 'Waiting Activation' ||
                                index?.attributes?.status[0] == 'Waiting Approval' ||
                                index?.attributes?.status[0] == 'Waiting Reset' ||
                                !acl.update ||
                                index?.roles?.[0]?.name == 'super_admin' ||
                                index?.roles?.[0]?.name == 'Super Admin'
                              }
                              checked={index.enabled}
                              onChange={(event, newValue1) =>
                                handleSwitchChange({ before: index.enabled, after: newValue1, id: index.id })
                              }
                              color="primary"
                              // value={index.is_active} // Assuming you want to use the switchState as the value
                              inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <Autocomplete
                              disabled={
                                index?.attributes?.status[0] == 'Waiting Activation' ||
                                index?.attributes?.status[0] == 'Waiting Approval' ||
                                index?.attributes?.status[0] == 'Waiting Reset' ||
                                !acl.update ||
                                index?.roles?.[0]?.name == 'super_admin' ||
                                index?.roles?.[0]?.name == 'data_viewer' ||
                                index?.roles?.[0]?.name == 'Super Admin' ||
                                index?.roles?.[0]?.name == 'Data Viewer'
                              }
                              id={`combo-box-demo-${index}`} // Unique ID for each Autocomplete
                              options={
                                index?.roles?.[0]?.name == 'super_admin' || index?.roles?.[0]?.name == 'data_viewer'
                                  ? data2
                                  : data2?.filter((element) => {
                                      return element.label !== 'super_admin' && element.label !== 'data_viewer';
                                    })
                              }
                              sx={{ width: 200 }}
                              value={(data2 || [])?.find(
                                (e) =>
                                  e?.label ===
                                  (index?.attributes?.status?.[0] == 'Waiting Approval'
                                    ? index?.attributes?.target_role?.[0]
                                    : index?.target)
                              )}
                              onChange={(event, newValue) =>
                                handleValueChange(
                                  `${t('AreYuSureChangeRole.1')} ${index?.roles?.[0]?.name} ${t(
                                    'AreYuSureChangeRole.2'
                                  )} ${newValue.label}`,
                                  event,
                                  newValue,
                                  index?.roles?.[0]?.name,
                                  index.id,
                                  'Waiting Approval',
                                  false,
                                  '',
                                  '',
                                  index?.attributes?.action?.[0]
                                )
                              }
                              renderInput={(params) => (
                                <TextField key={params.id} {...params} placeholder={index?.roles?.[0]?.name} />
                              )}
                            />
                            {isModalOpenrole && (
                              <div
                                id="popup-modal"
                                className="fixed top-0 right-0 left-0 bottom-0 overflow-y-auto overflow-x-hidden bg-gray-800 bg-opacity-50 z-50"
                              >
                                <div className="relative p-4 w-full max-w-md mx-auto">
                                  {/* Your modal content here */}
                                  <div className="bg-white rounded-lg shadow p-4">
                                    <button
                                      onClick={closeModal}
                                      className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                                    >
                                      {/* Close button SVG */}
                                    </button>
                                    {/* Other modal content */}
                                    <h3>Role is Changed</h3>
                                    <button onClick={handleYesClick}>Okay</button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </TableCell>
                          <TableCell component="th" scope="row" padding="none">
                            <IconButton
                              disabled={
                                index?.attributes?.status[0] == 'Waiting Activation' ||
                                index?.attributes?.status[0] == 'Waiting Approval' ||
                                index?.attributes?.status[0] == 'Waiting Reset' ||
                                // (index.status == 'Waiting Approval' && index?.attributes?.updated_by?.[0] !== username) ||
                                !acl.update ||
                                index?.roles?.[0]?.name == 'super_admin'
                              }
                              aria-label="more"
                              id="long-button"
                              aria-controls={opender ? 'long-menu' : undefined}
                              aria-expanded={opender ? 'true' : undefined}
                              aria-haspopup="true"
                              onClick={(event) => {
                                handleClickers(event, index.email);
                                handleclickdelete(event, index.id);
                                setRolevert(index);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                            <Menu
                              id="long-menu"
                              MenuListProps={{
                                'aria-labelledby': 'long-button',
                              }}
                              anchorEl={anchorEl}
                              open={opender}
                              onClose={handleClosing}
                            >
                              {rolevert?.roles?.[0]?.name != 'data_viewer' ? (
                                ''
                              ) : (
                                <MenuItem //onClick={handleClickOpen}
                                  onClick={() => {
                                    setInvitation((current) => ({ ...current, is_edit_dataset: 'true' }));
                                    handleClickOpen();
                                    handleClosing();
                                  }}
                                >
                                  {t('EditAccess.1')}
                                </MenuItem>
                              )}
                              <MenuItem onClick={handleresetChange}>{t('ResetPassword.1')}</MenuItem>
                              <Divider sx={{ my: 0.5 }} />
                              <MenuItem onClick={handleOpenDeleteModalder}>{t('DeleteUser.1')}</MenuItem>
                            </Menu>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    // Render something else when data.data is null or undefined
                    <p>No data available</p>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <FloatButton
            icon={<UserOutlined />}
            onClick={handleClickbutton}
            type="primary"
            tooltip={<div>{t('ViewUser.1')}</div>}
          />
          <Drawer
            style={{ marginTop: '6.5em', height: '100%', boxShadow: 'none' }}
            title={t('ViewUser.1')}
            onClose={onClosedraw}
            open={opendraw}
            placement="right"
          >
            <List
              size="small"
              itemLayout="horizontal"
              dataSource={filteredData}
              renderItem={(item, index) => (
                <List.Item>
                  <Avatar
                    sizes="small"
                    style={{
                      width: 25,
                      height: 25,
                      backgroundColor: 'green',
                      marginLeft: '0.2em',
                      marginRight: '0.8em',
                    }}
                  />
                  <List.Item.Meta title={item.username} />
                </List.Item>
              )}
            />
          </Drawer>
          <TablePagination
            count={data?.total || 0}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}

const rearrangeCheckedResults = (results) => {
  const map = new Map();
  const rearranged = [];

  const filteredData = results?.filter((item) => item.id) || [];
  filteredData.forEach((item) => map.set(item.id, item));
  filteredData.forEach((item) => {
    if (item.parent_id === '' || !map.has(item.parent_id)) {
      rearranged.push(item);
    } else {
      const parent = map.get(item.parent_id);
      if (parent.children) {
        parent.children.push(item);
      } else {
        parent.children = [item];
      }
    }
  });

  const flatten = (items) => {
    const flat = [];
    items.forEach((item) => {
      flat.push(item);
      if (item.children) {
        flat.push(...flatten(item.children));
        delete item.children;
      }
    });
    return flat;
  };

  return flatten(rearranged);
};
